import { forwardRef } from "react";
import { BsFillHandThumbsUpFill } from "react-icons/bs";
import styled from "styled-components";

import { ButtonProps } from "@/utils/types";

const Button = styled.button`
  border-radius: 50%;
  border: none;
  position: relative;
  background: none;
`;

const StyledBsFillHandThumbsUpFill = styled(BsFillHandThumbsUpFill).withConfig({
  shouldForwardProp: (prop) => !["isActive"].includes(prop),
})<{
  isActive: boolean;
}>`
  color: ${(props) => (props.isActive ? "#22b4d2" : "rgb(221, 221, 221);")};
  transition: color 0.3s ease;
`;

export const Good = forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    onButtonDown: () => void;
    isActive: boolean;
  }
>(({ className, onClick, onMouseDown, onButtonDown, isActive }, ref) => {
  const handleButtonDown = () => {
    onButtonDown();
  };

  return (
    <Button
      className={className}
      type="button"
      aria-label="good"
      ref={ref}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onPointerDown={handleButtonDown}
      onTouchStart={handleButtonDown}
    >
      <StyledBsFillHandThumbsUpFill isActive={isActive} size={24} />
    </Button>
  );
});
